import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class OnboardingColorsService {
    requestStatus: { [key: string]: any };

    constructor() {
        this.requestStatus = this.getColors().requestStatus;
    }
    getColorFunc(label: string, property: string) {
        //log.trace("getColorFunc");
      if (label && this.requestStatus[label.toLowerCase()]) {
            if (property) {
                return this.requestStatus[label.toLowerCase()][property];
            }
            return this.requestStatus[label.toLowerCase()].color;
        }
        return "";
    }

    getColors() {
        return {
          requestStatus: {
            "1": { color: "light-gold", hex: "#FFD700" },
            "2": { color: "lightning-yellow", hex: "#FFA500" },
            "3": { color: "red", hex: "#DC143C" },
            "4": { color: "light-blue", hex: "#1E90FF" },
            "5": { color: "vivid-violet", hex: "#800080" },
            "6": { color: "grass-green", hex: "#90EE90" },
            "7": { color: "grey", hex: "#808080" },
           // "7": { color: "sky-blue", hex: "#c0c0c0" },*/
            get: this.getColorFunc.bind(this)
          },
        };
    }
}
